import CampoSenha from "@/components/Formulario/CampoSenha";
import CampoTexto from "@/components/Formulario/CampoTexto";
import Grid, { GridItem } from "@/components/layout/Grid";
import { FormCamposProps } from "./FormCamposProps";
import { CanalChaveApiCodecTelegram, CanalChaveApiTelegram } from "@tera/shared/src/canalCodecs/CanalChaveApiCodecTelegram";

export const FormCamposTelegram = ({
    value,
    onChange,
    fieldErrors,
}: FormCamposProps) => {
    const codec = new CanalChaveApiCodecTelegram();
    const dadosApi: CanalChaveApiTelegram = value
        ? codec.decode(value)
        : { tipo: "telegram", token: "" };

    return (
        <Grid>
            <GridItem sm={12} md={6}>
                <CampoSenha
                    label="Token do Bot"
                    value={dadosApi.token}
                    onChange={(v) => onChange?.(codec.encode({ ...dadosApi, token: v }))}
                    autoFill="do-not-autofill-please"
                    error={fieldErrors?.['chave_api']}
                />
            </GridItem>
            <GridItem sm={12} md={6}>
                <CampoTexto
                    label="Usuário do Bot (@nome_bot)"
                    value={dadosApi.username ?? ''}
                    onChange={(v) => onChange?.(codec.encode({ ...dadosApi, username: v }))}
                    autoFill="do-not-autofill-please"
                    error={fieldErrors?.['chave_api.username']}
                />
            </GridItem>
        </Grid>
    );
};